var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedLoginCheckboxChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 0H3C1.35 0 0 1.35 0 3V17C0 18.65 1.35 20 3 20H17C18.65 20 20 18.65 20 17V3C20 1.35 18.65 0 17 0ZM14.46 8.21L9.46 13.21C9.26 13.4 9.01 13.5 8.75 13.5C8.49 13.5 8.24 13.4 8.04 13.21L5.54 10.71C5.15 10.32 5.15 9.68 5.54 9.29C5.93 8.9 6.57 8.9 6.96 9.29L8.75 11.09L13.04 6.79C13.43 6.4 14.07 6.4 14.46 6.79C14.85 7.18 14.85 7.82 14.46 8.21Z",
    fill: "#822AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedLoginCheckboxChecked);
export default __webpack_public_path__ + "static/media/v2_revamped_login_checkbox_checked.a119b6127333306e054db6949e378794.svg";
export { ForwardRef as ReactComponent };